"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReviewCoursesModal = exports.Groups = exports.Events = exports.Following = exports.Submissions = exports.Favorites = exports.Collections = exports.MyCourses = exports.Search = exports.GroupsModal = exports.TagSearchModal = exports.RewardsModal = exports.FavoritesModal = exports.SearchModal = exports.MyCoursesModal = exports.CollectionsModal = exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _SearchControl = babelHelpers.interopRequireDefault(require("components/SearchControl"));

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SearchModal = /*#__PURE__*/function (_Modal) {
  babelHelpers.inherits(SearchModal, _Modal);

  var _super = _createSuper(SearchModal);

  function SearchModal() {
    var _this;

    babelHelpers.classCallCheck(this, SearchModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.classList = _this.classList.concat('search-modal');
    return _this;
  }

  babelHelpers.createClass(SearchModal, [{
    key: "icon",
    get: function get() {
      return "<span class='material-icons' data-icon='search'></span>";
    }
  }, {
    key: "title",
    get: function get() {
      return "Search";
    }
  }, {
    key: "subTitle",
    get: function get() {
      return "";
    }
  }, {
    key: "modalContent",
    get: function get() {
      return "<div class='search-body-container'></div>";
    }
  }, {
    key: "getControl",
    value: function getControl() {
      return _SearchControl.default.getControl('search', {
        initialFilter: null
      });
    }
  }, {
    key: "show",
    value: function show() {
      var _babelHelpers$get,
          _this2 = this;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return (_babelHelpers$get = babelHelpers.get(babelHelpers.getPrototypeOf(SearchModal.prototype), "show", this)).call.apply(_babelHelpers$get, [this].concat(args)).then(function (element) {
        ReactDOM.render(_this2.getControl(), element.querySelector('.search-body-container'));
        $(element).find('.modal').on('hidden.bs.modal', function (event) {
          ReactDOM.unmountComponentAtNode(element.querySelector('.search-body-container'));
        });
        return element;
      });
    }
  }, {
    key: "showProducts",
    value: function showProducts() {
      return babelHelpers.get(babelHelpers.getPrototypeOf(SearchModal.prototype), "show", this).call(this).then(function (element) {
        ReactDOM.render(_SearchControl.default.getControl('search', {
          initialFilter: "product"
        }), element.querySelector('.search-body-container'));
        $(element).find('.modal').on('hidden.bs.modal', function (event) {
          ReactDOM.unmountComponentAtNode(element.querySelector('.search-body-container'));
        });
        return element;
      });
    }
  }, {
    key: "showDocuments",
    value: function showDocuments() {
      return babelHelpers.get(babelHelpers.getPrototypeOf(SearchModal.prototype), "show", this).call(this).then(function (element) {
        ReactDOM.render(_SearchControl.default.getControl('search', {
          initialFilter: ["document", "video"]
        }), element.querySelector('.search-body-container'));
        $(element).find('.modal').on('hidden.bs.modal', function (event) {
          ReactDOM.unmountComponentAtNode(element.querySelector('.search-body-container'));
        });
        return element;
      });
    }
  }]);
  return SearchModal;
}(_base.default);

exports.SearchModal = SearchModal;

var TagSearchModal = /*#__PURE__*/function (_SearchModal) {
  babelHelpers.inherits(TagSearchModal, _SearchModal);

  var _super2 = _createSuper(TagSearchModal);

  function TagSearchModal() {
    var _this3;

    babelHelpers.classCallCheck(this, TagSearchModal);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = _super2.call.apply(_super2, [this].concat(args));
    _this3.removeOnHide = true;
    return _this3;
  }

  babelHelpers.createClass(TagSearchModal, [{
    key: "getControl",
    value: function getControl() {
      return _SearchControl.default.getControl('search-tag', {
        searchProperties: {
          tag: this.tag
        }
      });
    }
  }], [{
    key: "show",
    value: function show(tag) {
      var tsm = new TagSearchModal('tag-search');
      tsm.tag = tag;
      return tsm.show();
    }
  }]);
  return TagSearchModal;
}(SearchModal);

exports.TagSearchModal = TagSearchModal;

var MyCoursesModal = /*#__PURE__*/function (_SearchModal2) {
  babelHelpers.inherits(MyCoursesModal, _SearchModal2);

  var _super3 = _createSuper(MyCoursesModal);

  function MyCoursesModal() {
    babelHelpers.classCallCheck(this, MyCoursesModal);
    return _super3.apply(this, arguments);
  }

  babelHelpers.createClass(MyCoursesModal, [{
    key: "icon",
    get: function get() {
      return "<span class='system-icon courses'></span>";
    }
  }, {
    key: "title",
    get: function get() {
      return "My Courses";
    }
  }, {
    key: "getControl",
    value: function getControl() {
      return _SearchControl.default.getControl('my-courses', {
        searchProperties: {
          courseProgress: 1
        }
      });
    }
  }]);
  return MyCoursesModal;
}(SearchModal);

exports.MyCoursesModal = MyCoursesModal;

var ReviewCoursesModal = /*#__PURE__*/function (_SearchModal3) {
  babelHelpers.inherits(ReviewCoursesModal, _SearchModal3);

  var _super4 = _createSuper(ReviewCoursesModal);

  function ReviewCoursesModal(id) {
    var _this4;

    babelHelpers.classCallCheck(this, ReviewCoursesModal);
    _this4 = _super4.call(this, 'review-courses-modal');
    _this4.catalogItem = id;
    return _this4;
  }

  babelHelpers.createClass(ReviewCoursesModal, [{
    key: "icon",
    get: function get() {
      return "<span class='system-icon courses'></span>";
    }
  }, {
    key: "title",
    get: function get() {
      return "Review Courses";
    }
  }, {
    key: "getControl",
    value: function getControl() {
      return _SearchControl.default.getControl('review-courses-' + this.catalogItem, {
        searchProperties: {
          courseProgress: 1,
          catalogItem: this.catalogItem
        }
      });
    }
  }]);
  return ReviewCoursesModal;
}(SearchModal);

exports.ReviewCoursesModal = ReviewCoursesModal;

var CollectionsModal = /*#__PURE__*/function (_SearchModal4) {
  babelHelpers.inherits(CollectionsModal, _SearchModal4);

  var _super5 = _createSuper(CollectionsModal);

  function CollectionsModal() {
    babelHelpers.classCallCheck(this, CollectionsModal);
    return _super5.apply(this, arguments);
  }

  babelHelpers.createClass(CollectionsModal, [{
    key: "icon",
    get: function get() {
      return "<span class='system-icon collections'></span>";
    }
  }, {
    key: "title",
    get: function get() {
      return "Collections";
    }
  }, {
    key: "getControl",
    value: function getControl() {
      return _SearchControl.default.getControl('collections', {
        searchProperties: {
          collections: 1
        }
      });
    }
  }]);
  return CollectionsModal;
}(SearchModal);

exports.CollectionsModal = CollectionsModal;

var FavoritesModal = /*#__PURE__*/function (_SearchModal5) {
  babelHelpers.inherits(FavoritesModal, _SearchModal5);

  var _super6 = _createSuper(FavoritesModal);

  function FavoritesModal() {
    babelHelpers.classCallCheck(this, FavoritesModal);
    return _super6.apply(this, arguments);
  }

  babelHelpers.createClass(FavoritesModal, [{
    key: "icon",
    get: function get() {
      return "<span class='system-icon favorites'></span>";
    }
  }, {
    key: "title",
    get: function get() {
      return "Favorites";
    }
  }, {
    key: "getControl",
    value: function getControl() {
      return _SearchControl.default.getControl('favorites', {
        searchProperties: {
          favorites: 1
        }
      });
    }
  }]);
  return FavoritesModal;
}(SearchModal);

exports.FavoritesModal = FavoritesModal;

var GroupsModal = /*#__PURE__*/function (_SearchModal6) {
  babelHelpers.inherits(GroupsModal, _SearchModal6);

  var _super7 = _createSuper(GroupsModal);

  function GroupsModal() {
    babelHelpers.classCallCheck(this, GroupsModal);
    return _super7.apply(this, arguments);
  }

  babelHelpers.createClass(GroupsModal, [{
    key: "icon",
    get: function get() {
      return "<span class='system-icon groups'></span>";
    }
  }, {
    key: "title",
    get: function get() {
      return "Groups";
    }
  }, {
    key: "getControl",
    value: function getControl() {
      return _SearchControl.default.getControl('groups', {
        searchProperties: {
          membershipGroups: 1
        }
      });
    }
  }]);
  return GroupsModal;
}(SearchModal);

exports.GroupsModal = GroupsModal;

var SubmissionsModal = /*#__PURE__*/function (_SearchModal7) {
  babelHelpers.inherits(SubmissionsModal, _SearchModal7);

  var _super8 = _createSuper(SubmissionsModal);

  function SubmissionsModal() {
    babelHelpers.classCallCheck(this, SubmissionsModal);
    return _super8.apply(this, arguments);
  }

  babelHelpers.createClass(SubmissionsModal, [{
    key: "icon",
    get: function get() {
      return "<span class='system-icon submissions'></span>";
    }
  }, {
    key: "title",
    get: function get() {
      return "Submissions";
    }
  }, {
    key: "getControl",
    value: function getControl() {
      return _SearchControl.default.getControl('submissions', {
        searchProperties: {
          submissions: 1
        }
      });
    }
  }]);
  return SubmissionsModal;
}(SearchModal);

var FollowingModal = /*#__PURE__*/function (_SearchModal8) {
  babelHelpers.inherits(FollowingModal, _SearchModal8);

  var _super9 = _createSuper(FollowingModal);

  function FollowingModal() {
    babelHelpers.classCallCheck(this, FollowingModal);
    return _super9.apply(this, arguments);
  }

  babelHelpers.createClass(FollowingModal, [{
    key: "icon",
    get: function get() {
      return "<span class='system-icon following'></span>";
    }
  }, {
    key: "title",
    get: function get() {
      return "Following";
    }
  }, {
    key: "getControl",
    value: function getControl() {
      return _SearchControl.default.getControl('following', {
        searchProperties: {
          following: 1
        }
      });
    }
  }]);
  return FollowingModal;
}(SearchModal);

var EventsModal = /*#__PURE__*/function (_SearchModal9) {
  babelHelpers.inherits(EventsModal, _SearchModal9);

  var _super10 = _createSuper(EventsModal);

  function EventsModal() {
    babelHelpers.classCallCheck(this, EventsModal);
    return _super10.apply(this, arguments);
  }

  babelHelpers.createClass(EventsModal, [{
    key: "icon",
    get: function get() {
      return "<span class='system-icon events'></span>";
    }
  }, {
    key: "title",
    get: function get() {
      return "Events";
    }
  }, {
    key: "getControl",
    value: function getControl() {
      return _SearchControl.default.getControl('events', {
        searchProperties: {
          events: 1
        }
      });
    }
  }]);
  return EventsModal;
}(SearchModal);

var rewardResults = {};

function resetRewards() {
  rewardResults = {};
}

function doRewards(id) {
  if (typeof document !== 'undefined') {
    $(document).off('profileUpdated', resetRewards);
    $(document).on('profileUpdated', resetRewards);
    if (rewardResults[id]) return rewardResults[id];
    return rewardResults[id] = (0, _fetch.default)("data/rewards/".concat(id)).then(function (result) {
      return result.json();
    });
  }
}

var RewardsModal = /*#__PURE__*/function (_SearchModal10) {
  babelHelpers.inherits(RewardsModal, _SearchModal10);

  var _super11 = _createSuper(RewardsModal);

  function RewardsModal(id, title, icon) {
    var _this5;

    babelHelpers.classCallCheck(this, RewardsModal);
    _this5 = _super11.call(this, "".concat(id, "-modal"));
    _this5.classList = _this5.classList.concat('rewards-modal');
    _this5.typeId = id;
    _this5.modalTitle = title;
    _this5.modalIcon = icon;
    return _this5;
  }

  babelHelpers.createClass(RewardsModal, [{
    key: "icon",
    get: function get() {
      if (this.modalIcon.type == 'system') return "<span class='system-icon ".concat(this.modalIcon.className, "'></span>");
      return "<img src='".concat(this.modalIcon.icon, "'>");
    }
  }, {
    key: "title",
    get: function get() {
      return this.modalTitle;
    }
  }, {
    key: "getControl",
    value: function getControl() {
      return _SearchControl.default.getControl(this.typeId, {
        typeId: this.typeId,
        doSearch: function doSearch(query) {
          return doRewards(this.typeId);
        }
      });
    }
  }], [{
    key: "modalForId",
    value: function modalForId(id, title, icon) {
      if (!this.knownModals[id]) {
        this.knownModals[id] = new RewardsModal(id, title, icon);
      }

      return this.knownModals[id];
    }
  }]);
  return RewardsModal;
}(SearchModal);

exports.RewardsModal = RewardsModal;
RewardsModal.knownModals = {};
var instance = new SearchModal("search-modal");
exports.Search = instance;
var _default = instance;
exports.default = _default;
var MyCourses = new MyCoursesModal('my-courses-modal');
exports.MyCourses = MyCourses;
var Collections = new CollectionsModal('collections-modal');
exports.Collections = Collections;
var Favorites = new FavoritesModal('favorites-modal');
exports.Favorites = Favorites;
var Submissions = new SubmissionsModal('submissions-modal');
exports.Submissions = Submissions;
var Following = new FollowingModal('following-modal');
exports.Following = Following;
var Events = new EventsModal('events-modal');
exports.Events = Events;
var Groups = new GroupsModal('groups-modal');
exports.Groups = Groups;